<ng-container *ngIf="markerPosition" >
    <google-map [height]="height" [width]="width" [center]="center" [zoom]="zoom" (mapClick)="addMarker($event)">
        <map-marker (mapDragend)="mapDragend($event)" [position]="markerPosition" [options]="markerOptions"></map-marker>
    </google-map>
</ng-container>
